import labelData from './../textConstants.json';

export var labelConstants = labelData.EN.TextConstants.Labels;
export var HomeListItemsConstants = labelData.EN.TextConstants.HomeListItems;
export var ButtonstConstants = labelData.EN.TextConstants.Buttons;
export var TextMessages = labelData.EN.Messages;

export const GUID_FOR_INITIAL_TOPIC_NAME = 'c774da81-94d5-4652-85c7-6ed0e8dc67e6';

// Project configurations
export const INITIAL_MESSAGES_SIZE = 2000;
export const MAXIMUM_LENGTH_OF_NAME = 10;
export const MAXIMUM_LENGTH_OF_MESSAGE = 8000;
export const MAXIMUM_LENGTH_OF_TOPIC = 30;
export const MAXIMUM_LENGTH_OF_TYPING_USERS = 35;
export const MINIMUM_TYPING_INTERVAL_IN_MILLISECONDS = 8000;
export const MAXIMUM_INT64 = 9223372036854775807;
export const NUMBER_OF_MESSAGES_TO_LOAD = 10;
export const PAGE_SIZE = 200;
export const PARTICIPANTS_THRESHOLD = 20;

// Keyboard keys
export const ENTER_KEY = 13;
export const SPACE_KEY = 32;

// Http Status Code
export const OK = 200;

// Regex
export const URL_REGEX = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;
export const EMPTY_MESSAGE_REGEX = /^\s*$/;

export class Constants {
    static INCOMING = 'Incoming';
    static RINGING = 'Ringing';
    static CONNECTING = 'Connecting';
    static CONNECTED = 'Connected';
    static DEFAULT_IMG_WIDTH = 200;
    static CROP_MEDIA = 'Crop';
    static CONFIGURATION_LOCAL_VIDEO_PREVIEW_ID = 'ConfigurationLocalVideoPreview';
    static LOCAL_VIDEO_PREVIEW_ID = 'LocalVideoPreview';
    static MINI_HEADER_WINDOW_WIDTH = 650;
    static SEPARATOR_HEADER_WINDOW_WIDTH = 570;
    // For safari browsers we want to set the default to 1 remote participant that can show their video based on quality constraints
    static DOMINANT_PARTICIPANTS_COUNT_SAFARI = 1;
    // For non-safari browsers we want to set the default to 4 remote participant that can show their video based on quality constraints
    static DOMINANT_PARTICIPANTS_COUNT = 4;
    static PING_USER_IN_SECONDS = 10;
    static HIDDEN_USER_PREFIX = "HDNUSR";
    static Secondary_USER_PREFIX = "2ndStream";
    static OBSERVER_CONNECTION_MS = 1800000; 

}

export class URLOptionsConstants {
    static THREADID = 'threadid';
    static USERID = 'userId';
    static MICROPHONEINDEX = 'microphoneIndex';
    static CAMERAINDEX = 'cameraIndex';
    static LANGUAGE = 'lang';
    static PROCTORCAMERA = 'proctorCamera';
    static CLOUDTOOLSENABLED = 'cloudToolsEnabled';
}

export const SetTextLanguage = (lang: number) => {
    switch (lang) {
        case FormLanguage.English:
            labelConstants = labelData.EN.TextConstants.Labels;
            HomeListItemsConstants = labelData.EN.TextConstants.HomeListItems;
            ButtonstConstants = labelData.EN.TextConstants.Buttons;
            TextMessages = labelData.EN.Messages;
            break;
        case FormLanguage.French:
            labelConstants = labelData.FR.TextConstants.Labels;
            HomeListItemsConstants = labelData.FR.TextConstants.HomeListItems;
            ButtonstConstants = labelData.FR.TextConstants.Buttons;
            TextMessages = labelData.FR.Messages;
            break;
        case FormLanguage.Chinese:
            labelConstants = labelData.CN.TextConstants.Labels;
            HomeListItemsConstants = labelData.CN.TextConstants.HomeListItems;
            ButtonstConstants = labelData.CN.TextConstants.Buttons;
            TextMessages = labelData.CN.Messages;
            break;
        case FormLanguage.German:
            labelConstants = labelData.DE.TextConstants.Labels;
            HomeListItemsConstants = labelData.DE.TextConstants.HomeListItems;
            ButtonstConstants = labelData.DE.TextConstants.Buttons;
            TextMessages = labelData.DE.Messages;
            break;
        case FormLanguage.Spanish:
            labelConstants = labelData.ES.TextConstants.Labels;
            HomeListItemsConstants = labelData.ES.TextConstants.HomeListItems;
            ButtonstConstants = labelData.ES.TextConstants.Buttons;
            TextMessages = labelData.ES.Messages;
            break;
        case FormLanguage.Greek:
            labelConstants = labelData.GR.TextConstants.Labels;
            HomeListItemsConstants = labelData.GR.TextConstants.HomeListItems;
            ButtonstConstants = labelData.GR.TextConstants.Buttons;
            TextMessages = labelData.GR.Messages;

        case FormLanguage.Italian:
            labelConstants = labelData.IT.TextConstants.Labels;
            HomeListItemsConstants = labelData.IT.TextConstants.HomeListItems;
            ButtonstConstants = labelData.IT.TextConstants.Buttons;
            TextMessages = labelData.IT.Messages;
            break;
        case FormLanguage.Japanese:
            labelConstants = labelData.JP.TextConstants.Labels;
            HomeListItemsConstants = labelData.JP.TextConstants.HomeListItems;
            ButtonstConstants = labelData.JP.TextConstants.Buttons;
            TextMessages = labelData.JP.Messages;
            break;
        case FormLanguage.Polish:
            labelConstants = labelData.PL.TextConstants.Labels;
            HomeListItemsConstants = labelData.PL.TextConstants.HomeListItems;
            ButtonstConstants = labelData.PL.TextConstants.Buttons;
            TextMessages = labelData.PL.Messages;
            break;
        default:
            labelConstants = labelData.EN.TextConstants.Labels;
            HomeListItemsConstants = labelData.EN.TextConstants.HomeListItems;
            ButtonstConstants = labelData.EN.TextConstants.Buttons;
            TextMessages = labelData.EN.Messages;
            break;
    }
}
//Should be Identical to the M2M FormLanguage
export enum FormLanguage {
    German = 7,

    Greek = 8,

    English = 69,

    Spanish = 85,

    French = 11,

    Italian = 15,

    Japanese = 16,

    Chinese = 67,//Chinese (People�s Republic of China)

    Arabic = 1,

    Polish = 20
}